import { render, staticRenderFns } from "./useTicketsMonth.vue?vue&type=template&id=0f2330c5&scoped=true"
import script from "./useTicketsMonth.vue?vue&type=script&lang=js"
export * from "./useTicketsMonth.vue?vue&type=script&lang=js"
import style0 from "./useTicketsMonth.vue?vue&type=style&index=0&id=0f2330c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2330c5",
  null
  
)

export default component.exports